/** Mirrors the backend TaskStatus enum. */
export const STATUSES = ["PENDING", "IN_PROGRESS", "HOLD", "COMPLETED", "CANCELLED"];

export const STATUS_LABELS = {
  PENDING: "Not started",
  IN_PROGRESS: "In progress",
  HOLD: "On hold",
  COMPLETED: "Done",
  CANCELLED: "Cancelled",
};

/**
 * A subtask is ticked by whoever holds it; the server enforces that (requireManageSubtask) and
 * `mine` carries the same answer to the screen, so the checkbox is never offered to be refused.
 */
export const canTick = (subtask) => Boolean(subtask?.mine);

export const subtaskProgress = (subtasks) => {
  const rows = Array.isArray(subtasks) ? subtasks : [];
  const done = rows.filter((row) => row?.completed).length;
  return {
    done,
    total: rows.length,
    label: rows.length === 0 ? "No subtasks" : `${done} of ${rows.length} done`,
  };
};

export const fileLabel = (file) => file?.name || "Attachment";

const normal = (value) =>
  String(value || "")
    .trim()
    .toLowerCase();

/**
 * Whether a comment was written by the signed-in partner user. A server flag or email wins; with
 * neither, the author's name is compared with the signed-in user's name.
 */
export const isMyComment = (comment, me = {}) => {
  if (typeof comment?.mine === "boolean") return comment.mine;
  if (comment?.authorEmail && me.email) return normal(comment.authorEmail) === normal(me.email);
  const author = normal(comment?.author);
  return Boolean(author) && (author === normal(me.name) || author === normal(me.email));
};
